<template>
  <div class="payment">
    <div class="paytopbox">
      <div class="paytopname">{{ orderdetail.status_str }}</div>
      <div class="paytopprice">￥{{ orderdetail.settlement_amount }}</div>
    </div>
    <div class="paymentlistbox">
      <div class="paymentlist">
        <div class="paymenttext">付款项目</div>
        <div class="paymentvalue">收回权益</div>
      </div>
      <div class="paymentlist">
        <div class="paymenttext">订单时间</div>
        <div class="paymentvalue">{{ orderdetail.created_at }}</div>
      </div>
      <div class="paymentlist">
        <div class="paymenttext">订单编号</div>
        <div class="paymentvalue">{{ orderdetail.recover_no }}</div>
      </div>
    </div>
    <div class="paymentbotton" @click="topay()" v-if="orderdetail.status == 10">
      立即支付
    </div>
    <div class="orderreturnindex1" @click="pageToIndex">返回首页</div>
  </div>
</template>

<script>
import httper from "../../api/http";
import { Dialog } from "vant";
import { Toast } from "vant";
const openLoading = () => {
  Toast.loading({
    message: "加载中",
    duration: 0 // toast不消失
  });
};
export default {
  data() {
    return {
      orderdetail: {}
    };
  },
  created() {
    this.recover_no = this.getQueryString("recover_no");
    this.request("recoverperview", {
      recover_no: this.recover_no
    });
  },
  methods: {
    pageToIndex() {
      this.$router.push({
        path: "/"
      });
    },
    getSourceByName(name) {
      name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
      var regexS = "[\\?&]" + name + "=([^&#]*)";
      var regex = new RegExp(regexS);
      var results = regex.exec(window.location.search);
      if (results == null) {
        return "";
      } else {
        return decodeURIComponent(results[1].replace(/\+/g, " "));
      }
    },
    getQueryString(name) {
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      if (window.location.hash.indexOf("?") < 0) return null;
      let r = window.location.hash.split("?")[1].match(reg);
      if (r != null) return decodeURIComponent(r[2]);
      return null;
    },
    // getParameterByName() {
    //   // window.location.href
    //   var url = window.location.href; //获取当前url
    //   //var dz_url = url.split('#')[0]; //获取#/之前的字符串
    //   var dz_url = window.location.hash;//从井号 (#) 开始的 URL
    //   var cs = dz_url.split('?')[1]; //获取?之后的参数字符串
    //   var cs_arr = cs.split('&'); //参数字符串分割为数组
    //   var cs = {};
    //   for (var i = 0; i < cs_arr.length; i++) { //遍历数组，拿到json对象
    //     cs[cs_arr[i].split('=')[0]] = cs_arr[i].split('=')[1]
    //   }
    //   this.order_no = cs.order_no; //这样就拿到了参数中的数据
    // },
    topay() {
      // this.$router.push({
      //   path: '/paysuccess'
      // })
      let order_param = {};
      order_param.type = "pack_recover";
      order_param.pay_type = "wechatpay";
      order_param.recover_no = this.recover_no;
      openLoading();
      this.request("WxunifiedOrder", order_param);
    },
    // 调用接口
    request(type = "", requestData = {}) {
      let that = this;
      switch (type) {
        //订单信息
        case "recoverperview":
          httper.get(
            "order/recover-preview",
            requestData,
            res => {
              if (res.code == 0) {
                this.orderdetail = res.data;
              } else {
                that.$toast({
                  message: res.message || "系统异常"
                });
              }
            },
            true
          );
          break;
        //微信下单
        case "WxunifiedOrder":
          httper.post(
            "/payment/unified-recover-order",
            requestData,
            res => {
              console.log("微信支付信息", res);
              if (res.code === 0) {
                that.pay(res.data.payment_packet, res.data.order_no);
              } else {
                Toast.clear();
                this.$toast({
                  message: res.message || "系统异常"
                });
              }
            },
            true
          );
          break;
        //微信取消下单
        case "orderCancel":
          httper.post(
            "/order/cancel",
            requestData,
            res => {
              console.log("取消", res);
              if (res.code === 0) {
                that.pay(res.data.payment_packet, res.data.order_no);
              } else {
                Toast.clear();
                this.$toast({
                  message: res.message || "系统异常"
                });
              }
            },
            true
          );
          break;
      }
    },
    //发起支付
    pay(payment_packet, order_no) {
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener(
            "WeixinJSBridgeReady",
            this.jsApiCall(payment_packet, order_no),
            false
          );
        } else if (document.attachEvent) {
          document.attachEvent(
            "WeixinJSBridgeReady",
            this.jsApiCall(payment_packet, order_no)
          );
          document.attachEvent(
            "onWeixinJSBridgeReady",
            this.jsApiCall(payment_packet, order_no)
          );
        }
      } else {
        this.jsApiCall(payment_packet, order_no);
      }
    },
    //调用微信支付
    jsApiCall(payment_packet, order_no) {
      let that = this;
      if (!payment_packet) {
        this.$toast({
          message: "下单失败，请重试"
        });
        return;
      }
      WeixinJSBridge.invoke("getBrandWCPayRequest", payment_packet, function(
        res
      ) {
        if (res.err_msg == "get_brand_wcpay_request:ok") {
          //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠
          setTimeout(function() {
            Toast.clear();
            window.location.reload(); //页面刷新
          }, 1500);
          //跳去详情页order_no
          // that.$router.push({
          //   path: '/paysuccess',
          //   query: {
          //     id: order_no
          //   }
          // })
        } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
          Toast.clear();
          that.$toast({
            message: "取消支付"
          });
          that.request("orderCancel", {
            order_id: order_no
          });
          // that.$router.push({
          //   name: 'list'
          // })
        } else {
          Toast.clear();
          that.$toast({
            message: "支付失败"
          });
        }
      });
    }
  }
};
</script>

<style scoped="scoped">
/*  body{
    background-color: #f7f7f7 !important;
  } */
.payment {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #f7f7f7;
}

.paytopbox {
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-weight: bold;
}

.paytopname {
  font-size: 19px;
  margin-bottom: 15px;
}

.paytopprice {
  font-size: 30px;
}

.paymentlistbox {
  width: 100%;
  margin-bottom: 20px;
  border-top: 1px solid #eaeaea;
  /* margin: 20px;
    padding: 10px;
    box-sizing: border-box; */
  background-color: #ffffff;
  border-radius: 8px;
  /* box-shadow: 0px 4px 5px 2px rgba(187, 187, 187, 0.3); */
}

.paymentlist {
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  border-bottom: 1px solid #eaeaea;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.paymenttext {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.5);
}

.paymentvalue {
  font-size: 14px;
  text-align: end;
}

.paymentbotton {
  width: calc(100% - 40px);
  height: 48px;
  margin: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  border-radius: 4px;
  background: #fd8c00;
  color: #ffffff;
}

.orderreturnindex1 {
  position: fixed;
  bottom: 50px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  color: rgba(0, 0, 0, 0.5);
}
</style>



// WEBPACK FOOTER //
// src/pages/payment/paymentpage.vue